module.exports = __webpack_public_path__ + "assets/img/0207.65b35a68.png";